<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>

        <!-- <div class="row">
            <div class="col-sm-12 form-group">
                <label for="motivoimpedimento">Motivo do Impedimento</label>
                <textarea 
                    class="form-control" rows="4" 
                    id="motivoimpedimento"
                    :value="motivo"
                    @input="bindMotivo($event.target.value.toUpperCase())">
                </textarea>
                <small v-if="motivo == ''" class="text-danger">campo obrigatório</small>
            </div>
        </div> -->


        <div class="row" v-if="selectsJustificativa">
            <div class="col-sm-6 form-group">
                <label for="catImpedimento">Categoria</label>
                <select id="catImpedimento" class="form-control" v-model="categoria">
                    <option value="" disabled>Selecione</option>
                    <option v-for="(item, index) in selectsJustificativa" :key="index" :value="item">{{item.nomeCategoria}}</option>
                </select>
                <small v-if="categoria == ''" class="text-danger">campo obrigatório</small>
            </div>

            <div class="col-sm-6 form-group" v-if="categoria != '' && categoria.id != 4 && categoria.id != 5">
                <label for="subcatImpedimento">Subcategoria</label>
                <select id="subcatImpedimento" class="form-control" v-model="subcategoria">
                    <option value="" disabled>Selecione</option>
                    <option v-for="(item, index) in selectsSubcategorias" :key="index" :value="item">{{item.nomeSubCategoria}}</option>
                </select>
                <small v-if="subcategoria == ''" class="text-danger">campo obrigatório</small>
            </div>
        </div>

         <div class="row">
            <div class="col-sm-6 form-group">
                <label for="data-picker">Data prevista para liberação</label>
                <datepicker
                    v-model="dataSemFormatacao"
                    :format="formatoData"
                    :disabled="dateDisabled"
                    language="pt-br"
                    id="data-picker"
                    calendar-button
                    calendar-button-icon="fa fa-calendar"
                    >
                </datepicker>
                <small v-if="dataSemFormatacao == ''" class="text-danger">preenchimento obrigatório</small>
            </div>

            <div class="col-sm-6 form-group">
                <label>Hora prevista para liberação</label>
                <input class="form-control" type="time" v-model="hora">
                <small v-if="hora == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>

        <button type="button" class="btn btn-primary" @click="validaSessao('impedirLeito')">Impedir o Leito</button>

    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    props: {
        dados: Object
    },
    components: {
        Datepicker,
    },
    mixins: [
        validaSessao
    ],
    created () {
        this.$store.dispatch('impedimento/selectsJustificativa')
    },
    data () {
        return {
            dataSemFormatacao: '',
            hora: '',
            formatoData: 'dd/MM/yyyy',
            dateDisabled: {
                to: new Date(new Date().setDate(new Date().getDate()-1))
            },
            categoria: '',
            subcategoria: ''
        }
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        selectsJustificativa () {
            return this.$store.getters['impedimento/getSelectsJustificativa']
        },
        selectsSubcategorias () {
            if (this.categoria == '') return null

            let item = this.selectsJustificativa.filter(i => i.nomeCategoria == this.categoria.nomeCategoria)
            return item[0].subCategoria
        }
    },
    watch: {
        categoria(value) {
            this.subcategoria = ''
        }
    },
    methods: {
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        impedirLeito () {
            if (this.categoria == '') return
            if (this.categoria.id != 4 && this.categoria.id != 5 && this.subcategoria == '') return
            if (this.dataSemFormatacao == '' || this.hora == '') return

            let datahora = this.formatadata(this.dataSemFormatacao)  + ' ' + this.hora + ':00'

            let motivo;
            this.categoria.id == 4 || this.categoria.id == 5
                ? motivo = this.categoria.nomeCategoria
                : motivo = this.categoria.nomeCategoria + ' - ' + this.subcategoria.nomeSubCategoria

            let dados = {
                dataHoraPrevisao: datahora,
                codigoEnfermaria: this.dados.leitoCodigoEnfermaria,
                codigoLeito: this.dados.leitoCodigo,
                motivoImpedimento: motivo
            }

            this.$emit('impedir', dados)
        }
    }
}
</script>